<template>
	<div class="content">
		<h3>产品出库</h3>
		<div class="item">
			<el-form ref="form" style="width:460px" :model="form" :rules="rules" label-width="100px">
				<el-form-item label="出库单号" prop="username">
					<el-input  v-model="form.username"></el-input>
				</el-form-item>
				<el-form-item label="出库库房" prop="password">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="出库类型" prop="factoryID">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in storage"
						:key="item.type"
						:label="item.storage"
						:value="item.type">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label=" ">
					<el-radio v-model="form.operate" :label='1'>扫描操作</el-radio>
					<el-radio v-model="form.operate" :label='0'>文件操作</el-radio>
				</el-form-item>
				<el-form-item label="操作物流码">
					<div v-if="form.operate==1">
						<el-input placeholder="请输入物流码"
						v-model="input" @change="add1()">
						</el-input>
						<div class="tag">
							<el-tag @close="delete1(index)" style="margin-right:10px" v-for="(tag, index) in WLData" :key="tag" closable>
								{{tag}}
							</el-tag>
						</div>
					</div>
					<div v-if="form.operate==0" style="width: 300px;display: -webkit-inline-box;">
						<el-upload style="width: 180px;"
							class="upload-demo"
							ref="upload"
							action="/FW/UploadFile.ashx"
							:auto-upload="false"
							:on-change="change"
							:on-success="success"
							:file-list="fileList">
							<el-button icon="el-icon-search" type="primary">选择文件</el-button>
							<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
						</el-upload>
						<el-button icon="el-icon-upload" type="primary" @click="upload">上传文件</el-button>
					</div>
				</el-form-item>
				<el-form-item label="备注" prop="note">
					<el-input type="textarea" ></el-input>
				</el-form-item>
				<el-checkbox v-model="productVisible" style="margin: 0 0 20px 100px;">修改产品相关信息</el-checkbox>
			</el-form>
			
			<el-form v-if="productVisible" ref="form" style="width:460px" :model="form" :rules="rules" label-width="100px">
				<el-form-item label="产品" prop="username">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产工厂" prop="password">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产车间" prop="factoryID">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in storage"
						:key="item.type"
						:label="item.storage"
						:value="item.type">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产线">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="生产班组">
					<el-select v-model="form.factoryID" placeholder="请选择">
						<el-option
						v-for="item in factory"
						:key="item.FactoryID"
						:label="item.FactoryName"
						:value="item.FactoryID">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="产品批号" prop="note">
					<el-input placeholder="请输入批号，不超过20个字符"></el-input>
				</el-form-item>
				<el-form-item label="生产日期">
					<el-date-picker style="width: 100%;display: block;"
						v-model="form.starttime" value-format="yyyy-MM-dd"
						type="date"
						placeholder="选择日期">
					</el-date-picker>
				</el-form-item>
			</el-form>
			<span style="margin: 0 0 20px 100px;">
				<el-button @click="restForm" type="warning">重 置</el-button>
				<el-button type="primary" @click="SetStorage">保 存</el-button>
			</span>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			form:{
				CID:'',
				factoryID:'',
				username:'',
				password:'',
				confirm:'',
				name:'',
				sex:'',
				tel:'',
				warehouse:'',
				state:'',
				isAgcy:'',
				Agcyname:'',
				operate:1
			},
			rules: {
        		factoryID:[
          			{ required: true, message: '请选择正确的工厂', trigger: 'change' }
        		],
        		username:[
          			{ required: true, message: '请输入用户名', trigger: 'blur' }
        		],
        		password:[
          			{ required: true, message: '请输入密码', trigger: 'blur' }
        		]
			},
			factory:[],
			storage:[{
				type:0,
				storage:"生产入库"
			},{
				type:1,
				storage:"退货入库"
			}],
			tableData: [],
			productVisible: false,
			input:'',
			WLData: [],
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
		this.form.CID=user.QyNum;

	},
	methods: {
		add1(){
			if(this.input!=""&&this.input!=null){
				this.WLData.push(this.input)
				this.input=null
			}
		},
		change(data){

		},
		success(response, file, fileList){
			if(response.Code==0){
				this.$message({
				showClose: true,
				message: response.Msg,
				type: "success"
				});
			}else{
				this.$message({
				showClose: true,
				message: response.Msg,
				type: "warning"
				});
			}   
		},
		upload(){
			this.$refs.upload.submit()
		},
		delete1(index){
			this.WLData.splice(index,1)	
		},
		SelectStorage(){},
		AddStorage(){
			this.dialogVisible=true;
		},
		UpdataStorage(){},
		DisableStorager(){},
		SetStorage(){

			this.dialogVisible=false;
		},
		restForm(){},
		SetStorage(){}
	}
}
</script>

<style scoped>
.title{
  text-align: left;
}
.btn{
	margin:0 0 10px 30px;
}
.el-select{
	display: inline;
}
</style>


// WEBPACK FOOTER //
// src/pages/productWarehouseOut.vue